import { useSelector } from 'react-redux';
import { accountSelectors } from '../redux/modules/account';
import { Account } from '../common/types/Accounts';

export const useActiveAccount = (): Account | undefined =>
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  useSelector(accountSelectors.selectActiveAccount);

export default useActiveAccount;
